import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "core-values-container",
  class: "text-blue"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "core-values-header section-max-w mlr-auto" }, "The Three C's", -1)
const _hoisted_3 = { class: "core-values-list-container flex j-evenly section-max-w mlr-auto" }
const _hoisted_4 = { class: "value-title static-large" }
const _hoisted_5 = { class: "value-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coreValues, (value) => {
        return (_openBlock(), _createElementBlock("div", {
          key: value.title,
          class: "core-value-item"
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(value.title), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(value.text), 1)
        ]))
      }), 128))
    ])
  ]))
}